import React, { Component } from "react";

import UserData from "./components/UserData";
class UserDataPage extends Component {
  render() {
    return (
        <UserData history={this.props.history}/>
    );
  }
}

export default UserDataPage;
